var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3431 0.479417L31.7071 6.84338C32.0976 7.2339 32.0976 7.86707 31.7071 8.25759L25.3431 14.6216C24.9526 15.0121 24.3195 15.0121 23.9289 14.6216C23.5384 14.231 23.5384 13.5979 23.9289 13.2073L28.5858 8.55048H1C0.447715 8.55048 0 8.10277 0 7.55048C0 6.9982 0.447715 6.55048 1 6.55048H28.5858L23.9289 1.89363C23.5384 1.50311 23.5384 0.869941 23.9289 0.479417C24.3195 0.0888923 24.9526 0.0888923 25.3431 0.479417Z",
    fill: "#5D38E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f0545da9998bf0cf64b664650a0a13e4.svg";
export { ForwardRef as ReactComponent };